<ifr-page-title pageTitle="'LEFT_PANEL_DEVELOPER' | translate " />

<developer />
